// IE Hub - Scroll to Top Hook
// Automatically scrolls to top when pathname changes

import { useEffect } from 'react';

export function useScrollToTop(pathname: string): void {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
}

export default useScrollToTop;
